import { EmptyStatePlaceholder } from '@/components/molecules/empty-state-placeholder';
import { AcknowledgedAlarmsTable } from '@/features/alarms/alarm-tables/acknowledged-alarms-table';
import {
  acknowledgedAlarmActivationFilter,
  unacknowledgedAlarmActivationFilter,
} from '@/features/alarms/alarm-tables/helpers';
import { UnacknowledgedAlarmsTable } from '@/features/alarms/alarm-tables/unacknowledged-alarms-table';
import { useDeviceAlarmActivations } from '@/hooks/query-hooks/alarm-activations';

import { AlarmTableProps } from './types';

export const EquipmentDetailsAlarmTable = ({
  deviceId,
  containerRef,
  tableView,
}: AlarmTableProps) => {
  const activeAlarms = useDeviceAlarmActivations({ deviceId });

  const unacknowledgedAlarms = (activeAlarms || []).filter(unacknowledgedAlarmActivationFilter);
  const acknowledgedAlarms = (activeAlarms || []).filter(acknowledgedAlarmActivationFilter);

  switch (tableView) {
    case 'unacknowledged-alarms':
      if (unacknowledgedAlarms.length === 0) {
        return <EmptyStatePlaceholder message="No unacknowledged alarms present" />;
      }
      return (
        <UnacknowledgedAlarmsTable alarms={unacknowledgedAlarms} containerRef={containerRef} />
      );
    case 'acknowledged-alarms':
      if (acknowledgedAlarms.length === 0) {
        return <EmptyStatePlaceholder message="No acknowledged alarms present" />;
      }
      return <AcknowledgedAlarmsTable alarms={acknowledgedAlarms} containerRef={containerRef} />;
    default:
      return null;
  }
};
